export const Filter = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M21 17h-4m-4 0H3M3 7h4m4 0h10m-7 7h2a1 1 0 011 1v4a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4a1 1 0 011-1zm-4-4H8a1 1 0 01-1-1V5a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1z'
        ></path>
      </svg>
    </span>
  );
};
